import decode from 'jwt-decode';
import { getSolissB2CRefreshTokenServiceUrl, getSolissB2CTokenServiceUrl } from '../../configurations/environmentVariables';
import { TokensResponse } from '../../types/users/TokensResponse';
import { ROL_RANK_SUPERVISOR, ROL_RANK_CARGA, ROL_RANK_VISUALIZADOR } from '../../types/users/rolesTypes';
import { getTokenFromStorage, setStorageToken } from '../../utils/token.store';

export class AuthHandler {

    public isTokenExpired = (token: string) => {
        const decodedToken: any = decode(token);
        return (Math.floor((new Date()).getTime() / 1000)) >= decodedToken.exp;
    }

    getAPIToken = async () => {

        if (window !== undefined) {

            const apiToken = getTokenFromStorage();

            if (apiToken !== undefined && apiToken.token) {

                const isExpired = this.isTokenExpired(apiToken.token);
                if (!isExpired) {

                    return apiToken.token;
                }
                else {
                    const refreshedToken = await this.refreshToken();

                    if (refreshedToken && refreshedToken.token) {
                        setStorageToken(refreshedToken.token, null);

                        return refreshedToken.token;
                    }
                }
            }
        }

        return undefined;
    }

    getTokensFromB2C = async (jwtB2C: string)
        : Promise<TokensResponse | null> => {

        const url = getSolissB2CTokenServiceUrl();

        const resp = await fetch(url, {
            credentials: "include",
            headers: { Authorization: "Bearer " + jwtB2C },
        });

        if (resp !== undefined) {

            const response = await resp.json();

            const roles = process.env.REACT_APP_ENVIRONMENT === "DEV"
                ? [...response.roles, ROL_RANK_SUPERVISOR, ROL_RANK_CARGA, ROL_RANK_VISUALIZADOR]
                : response.roles;

            return { ...response, roles } as TokensResponse;
        }

        throw new Error('Error al obtener tokens');
    }

    refreshToken = async () => {

        const url = getSolissB2CRefreshTokenServiceUrl();
        const tokens = getTokenFromStorage();

        if (!tokens.token || !tokens.usuarioId) {
            throw new Error('No hay tokens disponibles para refrescar');
        }

        const resp = await fetch(url, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                token: tokens.token,
                usuarioId: tokens.usuarioId,
            }),
        });

        const response = await resp.json();
        if (!response.token) {
            throw new Error('Error al actualizar tokens');
        }

        return response as TokensResponse;
    }
}